import React, { useEffect } from "react"
import { TiLocationOutline } from "react-icons/ti"
import { HiGlobeAlt, HiPhone } from "react-icons/hi2"
import { MdEmail } from "react-icons/md"

import {
  Contact,
  ContactForm,
  ContactIconText,
  ContactText,
  Header,
  Line,
} from "./style"
import ContactUs from "components/Forms/ContactUs"
import YMaps from "../../components/YMaps"
import { useTranslation } from "react-i18next"
import { FiArrowLeft } from "react-icons/fi"
import { useNavigate } from "react-router-dom"

export default () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 })
  }, [])

  return (
    <div className="bg-[rgba(57,57,57,.8)] font-[Roboto] w-full h-full 2xl:px-40 xl:px-12 lg:px-10 md:px-10 px-5 flex flex-col text-white font-medium justify-center items-left py-10">
      <button
        onClick={() => navigate(-1)}
        className="flex items-center justify-start text-base gap-2 cursor-pointer mb-8"
      >
        <FiArrowLeft size={25} />
        <span className="text-xl font-medium">{t("back")}</span>
      </button>
      <div>
        <Header
          className="w-full flex lg:justify-start md:justify-center sm:justify-start justify-start font-semibold"
          size="32px"
        >
          {t("for-connecting")}
        </Header>
        <div className="w-full lg:flex md:flex sm:hidden hidden lg:justify-start md:justify-center sm:justify-center">
          <Line />
        </div>
      </div>
      <Contact className="w-full flex 2xl:justify-between xl:justify-between lg:justify-between flex-wrap md:justify-center font-[Inter]">
        <ContactText className="2xl:w-1/3 xl:w-2/5 lg:w-1/2 md:w-11/12 sm:w-full w-full">
          <div className=" flex justify-between w-full flex-wrap text-white">
            <div>
              <ContactIconText>
                <span>
                  <HiPhone size={20} color="white" />
                </span>
                <p>
                  <a href="tel:+99873 244-05-35" target="blank">
                    +99873 244-05-35
                  </a>
                </p>
              </ContactIconText>
              <ContactIconText>
                <span>
                  <MdEmail size={20} color="white" />
                </span>
                <p>farmarkaz@ferghana.uz</p>
              </ContactIconText>
              <ContactIconText>
                <span>
                  <HiGlobeAlt size={20} color="white" />
                </span>
                <p>fcc.uz</p>
              </ContactIconText>
            </div>
            <ContactIconText
              className="xl:w-5/12 lg:w-5/12 md:w-5/12 sm:w-full w-full"
              start="true"
            >
              <span>
                <TiLocationOutline size={24} color="white" />
              </span>
              <p>{t("connecting-address")}</p>
            </ContactIconText>
          </div>
          <p>{t("connecting-address-full")}</p>
        </ContactText>

        <ContactForm className="2xl:w-2/5 xl:w-2/5 lg:w-1/2 md:w-11/12 sm:w-full w-full lg:pl-10 md:p-0 sm:p-0">
          <ContactUs />
        </ContactForm>
      </Contact>

      <div className="w-ful mt-10">
        <div>
          <p className="font-semibold text-white text-[32px]">
            {t("finding-in-map")}
          </p>
          <Line />
        </div>

        <div className="w-full h-[550px]">
          <YMaps />
        </div>
      </div>
    </div>
  )
}
